import ClientDashboard from './ClientDashboardContainer';

export default ClientDashboard;
